import axios from 'axios';

import { END_POINTS } from '@constants/api-endpoints';
import { ErrorCodes } from '@enums/error';
import { SelectWorkspaceResponse } from '@pages/select-workspace/types';
import { clearFromLocalStorage, getAuthToken } from '@utils/auth';

import { HttpMethod } from './enums';
import { RegenerateTokenParams } from './types';

export const regenerateToken = async ({
  clientUuid,
  ignoreSingleClientToken = false,
  logoutOnError = false,
}: RegenerateTokenParams) => {
  try {
    const token = getAuthToken({
      clientUuid,
      chooseLastClientUuid: true,
      ignoreSingleClientToken,
    });

    if (!token) {
      console.error('Token is not available');
      throw new Error(ErrorCodes.BD_UNAUTHORIZED);
    }

    const instance = axios.create({
      withCredentials: true,
    });

    const response = await instance.request<SelectWorkspaceResponse>({
      method: HttpMethod.GET,
      baseURL: "https://api.brandtechbrain.com/api/",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: END_POINTS.WORKSPACE.SELECT_CLIENT(clientUuid as string),
    });

    return response.data;
  } catch (error) {
    if (logoutOnError) {
      clearFromLocalStorage();
      throw new Error(ErrorCodes.BD_UNAUTHORIZED);
    }

    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      const errorCode = data?.code;

      // For access denied and client not found, don't clear localStorage and don't throw BD_UNAUTHORIZED
      if (
        (status === 403 &&
          errorCode === ErrorCodes.BD_USER_WORKSPACE_ACCESS_DENIED) ||
        (status === 404 && errorCode === ErrorCodes.BD_CLIENT_NOT_FOUND)
      ) {
        throw error; // Re-throw the original error
      }
    }

    // For all other errors, clear localStorage and throw BD_UNAUTHORIZED
    clearFromLocalStorage();
    throw new Error(ErrorCodes.BD_UNAUTHORIZED);
  }
};
